export default "__VITE_ASSET__bfd2d296__"